<template>
    <div>
        <div v-if="useTitle"
             class="pb-4 flex items-center space-x-12"
        >
            <div class="flex items-center space-x-12">
                <svg-icon class="w-20 h-20 text-primary-80" type="task-alt"></svg-icon>

                <p class="flex items-center text-body font-semibold">
                    {{ $t('tasks.tasks') }}
                </p>
            </div>

            <simple-dropdown class="-ml-2 text-primary">
                <template #trigger>
                    <button
                        class="p-8 hover:bg-primary-5 rounded"
                        role="button"
                    >
                        <svg-icon class="max-w-16 max-h-16" type="more-horiz"/>
                    </button>
                </template>
                <template #content="{ close }">
                    <div aria-labelledby="option-menu"
                         aria-orientation="vertical"
                         class="bg-white relative rounded shadow-md p-8 space-y-8 z-top"
                         role="menu"
                    >
                        <checkbox
                            v-model="showOnlyMyTasks"
                            class="mr-8 whitespace-nowrap"
                        >
                            <span class="font-normal">{{ $t('tasks.my_tasks_only') }}</span>
                        </checkbox>
                        <checkbox
                            v-model="showFinishedTasks"
                            class="mr-8"
                        >
                            <span class="font-normal">{{ $t('tasks.tasks_done') }}</span>
                        </checkbox>
                    </div>
                </template>
            </simple-dropdown>
        </div>

        <simple-button
            class="w-full my-12"
            display="secondary"
            icon="add"
            icon-position="left"
            @click="mainStore.startAddingTask(context)"
        >
            {{ $t('tasks.add_task') }}
        </simple-button>

        <task-list
            :key="'todo-tasks_' + _uid"
            :class="maxHeight"
            :context="context"
            :context-changes="contextChanges"
            :finished="showFinishedTasks"
            :show-all="!showOnlyMyTasks"
            can-add
            @navigation="$emit('navigation')"
        ></task-list>
    </div>
</template>

<script>
import TaskList from './TaskList.vue';
import SvgIcon from './SvgIcon.vue';
import SimpleDropdown from './SimpleDropdown.vue';
import Checkbox from '../forms/Checkbox';
import SimpleButton from "./SimpleButton.vue";
import {mapStores} from "pinia";
import {useMainStore} from "../../state/store";

export default {
    components: {
        SimpleButton,
        Checkbox,
        'task-list': TaskList,
        'svg-icon': SvgIcon,
        'simple-dropdown': SimpleDropdown,
    },
    props: {
        context: Object,
        filterable: Boolean,
        maxHeight: {
            type: String,
            default: '',
        },
        useTitle: {type: Boolean, default: true},
    },
    data: function () {
        return {
            showOnlyMyTasks: this.filterable,
            showFinishedTasks: false,
            contextChanges: 0,
        };
    },
    computed: {
        ...mapStores(useMainStore),
    },
    methods: {
        setOnlyMyTasks() {
            return this.showOnlyMyTasks = !this.showOnlyMyTasks;
        },
        setShowFinishedTasks() {
            return this.showFinishedTasks = !this.showFinishedTasks;
        },
    },
    watch: {
        showOnlyMyTasks() {
            this.contextChanges += 1;
        },
        showFinishedTasks() {
            this.contextChanges += 1;
        }
    },
};
</script>
